// eslint-disable-next-line import/no-named-as-default
import api from './base.service';

export const getAll = () => {
  return api().get('/api/student-mentors');
};

export const getByStudentId = (id) => {
  return api().get(`/api/student-mentors/student/${id}`);
};

export const saveUserOjtiList = (payload) => {
  return api().post('/api/student-mentors/all', payload);
};

export const edit = (payload) => {
  return api().put('/api/student-mentors', payload);
};

export const deleteMentor = (id) => {
  return api().delete(`/api/student-mentors/${id}`);
};

export const getFreeSubstituteMentors = (studentId, dateFrom, dateTo) => {
  return api().get(`/api/student-mentors/free-ojti?studentId=${studentId}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
};

export const getAllOjtiByAtcu = (atcu) => {
  return api().get(`/api/users/ojti/${atcu}`);
};
